<template>
  <div class="page">
     <div class="dialog" @click="handleClosed">
    </div>
    <div class="content" style="display: flex;">
      <div class="mainBox">
        <div class="title">关于本场招聘会</div>
        <div class="img-box" >
          <img :src="jobfairIcon.image" alt="" width="668px" object-fit:content>
        </div>
      </div>
      <Icon class="closeBtn" type="ios-close" width="32px" hight="32px" @click="handleClosed"></Icon>
    </div>
  </div>
   
</template>

<script>
    export default {
      props: {
        jobfairIcon: {
          type: Object,
          default: ''
        }
      },
      data() {
        return {
          loadingFlag: true,
        }
      },
      methods: {
        handleClosed() {
          this.$emit('handleClosed')
        }
      },
      watch: {
        
      }
    }
</script>

<style scoped lang="less">
    .page{
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          position: fixed;
          z-index: 3;
    }
   .dialog {
       position: relative;
      //  top: 0;
      //  left: 0;
       width: 100%;
       height: 100%;
       background-color: rgba(0,0,0,0.6);
       display: flex;
       justify-content: center;
       align-items: center;
       z-index: 9998;
      }
      .content{

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 9999;
        border-radius: 8px;
        .mainBox {
            width: 748px;
            height: 562px;
            background-color: #FFFFFF;
            border-radius: 8px;
            // margin-right: 12px;
            .title{
                width: 100%;
                height: 80px;
                background: url(../../assets/about-bg.png) no-repeat;
                background-size: 100% 100%;
                font-size: 18px;
                font-weight: bold;
                color: #17233D;
                text-align: center;
                padding-top: 40px;
            }
            .img-box{
                // margin-top: 80px;
                margin-top: 16px;
                text-align: center;
                // width: 670px;
                height: 432px;
                overflow-y:scroll;
            }
         }
         .closeBtn {
            z-index: 9999;
             width: 32px;
             height: 32px;
             color: rgba(255,255,255,0.8);
             //  position: absolute;
             //  right: -10px;
             //  top: -30px;
             font-size: 34px;
             font-weight: bold;
         }
         .closeBtn:hover {
             cursor: pointer;
             color: #ffffff;
         }
      }
</style>



// WEBPACK FOOTER //
// src/components/dialog/aboutJobfair.vue